export const BetaBanner = () => {
    return null;
};
